import {eventNames} from './const/eventNames.js'

export interface BackendEvent<T = unknown> {
	event: string
	args: { parameter: T; metadata: unknown }
}

export const backendEventsFactory = {
	createExportStarted(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportStarted,
			args: {
				parameter: state,
				metadata
			}
		}

		return result;
	},
	createExportStarting(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportStarting,
			args: {
				parameter: state,
				metadata
			}
		}

		return result;
	},
	createExportChanged(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportChanged,
			args: {
				parameter: state,
				metadata
			}
		}
		return result;
	},
	createExportFailed(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportFailed,
			args: {
				parameter: state,
				metadata
			}
		}
		return result;
	},
	createExportCompleting(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportCompleting,
			args: {
				parameter: state,
				metadata
			}
		}
		return result;
	},
	createExportCompleted(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportCompleted,
			args: {
				parameter: state,
				metadata
			}
		}
		return result;
	},
	createExportCleared(state: unknown, metadata: unknown): BackendEvent {
		const result = {
			event: eventNames.exportCleared,
			args: {
				parameter: state,
				metadata
			}
		}
		return result;
	}
}
